module.exports = __webpack_public_path__ + "img/btn-fix-no-open.193de036.png";